export default __webpack_public_path__ + "static/media/arrow-right1.227cb0df.svg";